(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-main-product"]) return;
  try {
    
  if (!window.customElements.get('td-fetched-content')) {
    class TDFetchedContent extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';

        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.text();
          })
          .then((response) => {
            // Parse into <template> so custom elements in the fetched HTML
            // are not upgraded during parse — prevents <product-form
            // data-redirect> in the recommendations section response from
            // triggering window.location.href on construction.
            const tmpl = document.createElement('template');
            tmpl.innerHTML = response;
            const match = tmpl.content.querySelector('[data-id="' + this.dataset.id + '"]');
            if (match) this.innerHTML = match.innerHTML;
          })
          .catch((err) => {
            console.warn('td-fetched-content fetch failed:', err);
          });
      }
    }
    window.customElements.define('td-fetched-content', TDFetchedContent);
  }

  if (!window.customElements.get('td-badge-modal')) {
    class TDBadgeModal extends HTMLElement {
      static selectors = {
        trigger: '[data-td-badge-modal-trigger]',
        panel: '[data-td-badge-modal-panel]',
        close: '[data-td-badge-modal-close]'
      };

      connectedCallback() {
        this.trigger = this.querySelector(TDBadgeModal.selectors.trigger);
        this.panel = this.querySelector(TDBadgeModal.selectors.panel);
        this.closeButton = this.querySelector(TDBadgeModal.selectors.close);

        if (!this.trigger || !this.panel || !this.closeButton) return;

        this.handleTriggerClick = this.handleTriggerClick.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
        this.handleDocumentFocusIn = this.handleDocumentFocusIn.bind(this);
        this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);

        this.trigger.addEventListener('click', this.handleTriggerClick);
        this.closeButton.addEventListener('click', this.handleCloseClick);
        this.close();
      }

      disconnectedCallback() {
        if (this.trigger) {
          this.trigger.removeEventListener('click', this.handleTriggerClick);
        }
        if (this.closeButton) {
          this.closeButton.removeEventListener('click', this.handleCloseClick);
        }
        this.removeDocumentListeners();
      }

      handleTriggerClick() {
        if (this.dataset.tdBadgeModalState == 'open') {
          this.close();
        } else {
          this.open();
        }
      }

      handleCloseClick() {
        this.close();
      }

      handleDocumentPointerDown(event) {
        if (!this.contains(event.target)) {
          this.close();
        }
      }

      handleDocumentFocusIn(event) {
        if (!this.contains(event.target)) {
          this.close();
        }
      }

      handleDocumentKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
        }
      }

      addDocumentListeners() {
        document.addEventListener('pointerdown', this.handleDocumentPointerDown, true);
        document.addEventListener('focusin', this.handleDocumentFocusIn, true);
        document.addEventListener('keydown', this.handleDocumentKeydown);
      }

      removeDocumentListeners() {
        document.removeEventListener('pointerdown', this.handleDocumentPointerDown, true);
        document.removeEventListener('focusin', this.handleDocumentFocusIn, true);
        document.removeEventListener('keydown', this.handleDocumentKeydown);
      }

      open() {
        document.querySelectorAll('td-badge-modal[data-td-badge-modal-state="open"]').forEach((modal) => {
          if (modal !== this && typeof modal.close === 'function') {
            modal.close();
          }
        });

        this.dataset.tdBadgeModalState = 'open';
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
        this.addDocumentListeners();
        this.panel.focus();
      }

      close() {
        this.dataset.tdBadgeModalState = 'closed';
        if (this.trigger) {
          this.trigger.setAttribute('aria-expanded', 'false');
        }
        if (this.panel) {
          this.panel.hidden = true;
        }
        this.removeDocumentListeners();
      }
    }

    window.customElements.define('td-badge-modal', TDBadgeModal);
  }

  if (!window.customElements.get('td-sticky-cta')) {
    class TDStickyCTA extends HTMLElement {
      static selectors = {
        mainButton: '#PDPAddToCartBtn',
        trigger: '[data-td-sticky-cta-trigger]',
        options: '[data-td-sticky-cta-options]',
        summary: '[data-td-sticky-cta-summary]',
        close: '[data-td-sticky-cta-close]',
        image: '[data-td-sticky-cta-img]',
        price: '[data-td-sticky-cta-price]',
        summaryOptions: '[data-td-sticky-cta-summary-options]',
        variantPicker: 'variant-picker'
      };

      static activeClass = 'td-sticky-cta--active';
      static hiddenClass = 'td-hide';
      static resetDelay = 500;

      connectedCallback() {
        this.form = this.closest('product-form');
        this.mainButton = this.form?.querySelector(TDStickyCTA.selectors.mainButton);
        this.trigger = this.querySelector(TDStickyCTA.selectors.trigger);
        this.summary = this.querySelector(TDStickyCTA.selectors.summary);

        if (!this.mainButton || !this.trigger || !this.summary) return;

        this.optionsPanel = this.querySelector(TDStickyCTA.selectors.options);
        this.active = false;

        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleAdded = this.handleAdded.bind(this);
        this.handleAvailabilityChange = this.handleAvailabilityChange.bind(this);
        this.handleMediaChange = this.handleMediaChange.bind(this);
        this.handleIntersection = this.handleIntersection.bind(this);

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.form.addEventListener('on:cart:sticky-add', this.handleAdded);
        if (this.optionsPanel) {
          this.form.addEventListener('on:availability:change', this.handleAvailabilityChange);
        }

        // Keep in sync with the `.td-sticky-cta--active` media query in assets/td-main-product.css.
        this.mediaQuery = window.matchMedia('(max-width: 768px)');
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
        this.handleMediaChange();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.form?.removeEventListener('on:cart:sticky-add', this.handleAdded);
        this.form?.removeEventListener('on:availability:change', this.handleAvailabilityChange);
        this.mediaQuery?.removeEventListener('change', this.handleMediaChange);
        this.stopObserving();
        clearTimeout(this.resetTimer);
      }

      // Observe the main Add to Cart only on mobile, where the bar is shown.
      handleMediaChange() {
        if (this.mediaQuery.matches) {
          this.startObserving();
        } else {
          this.stopObserving();
          this.setActive(false);
        }
      }

      startObserving() {
        if (this.observer) return;
        this.observer = new IntersectionObserver(this.handleIntersection, { threshold: 1 });
        this.observer.observe(this.mainButton);
      }

      stopObserving() {
        this.observer?.disconnect();
        this.observer = null;
      }

      // Show the bar whenever the rendered main Add to Cart is not fully visible (below the fold or scrolled past).
      handleIntersection(entries) {
        const entry = entries[entries.length - 1];
        this.setActive(entry.intersectionRatio < 1 && entry.boundingClientRect.height > 0);
      }

      setActive(active) {
        if (this.active === active) return;

        this.active = active;
        this.classList.toggle(TDStickyCTA.activeClass, active);
        this.inert = !active;
        clearTimeout(this.resetTimer);

        if (!active) {
          this.resetTimer = setTimeout(() => this.reset(), TDStickyCTA.resetDelay);
        }
      }

      handleClick(event) {
        const target = event.target;

        if (target.closest(TDStickyCTA.selectors.close)) {
          this.reset();
          this.trigger.focus();
        } else if (target.closest(TDStickyCTA.selectors.trigger)) {
          this.handleTrigger();
        } else if (this.optionsPanel && target.matches('input[type="radio"]')) {
          this.selectOption(target);
        }
      }

      handleKeydown(event) {
        if (event.key !== 'Escape' || !this.trigger.classList.contains(TDStickyCTA.hiddenClass)) return;

        this.reset();
        this.trigger.focus();
      }

      handleTrigger() {
        if (!this.optionsPanel) {
          this.form.dispatchEvent(new CustomEvent('sticky-cta-add'));
          return;
        }

        this.showPanel(this.optionsPanel);
        this.trigger.setAttribute('aria-expanded', 'true');
        this.optionsPanel.querySelector('input[type="radio"]')?.focus();
      }

      selectOption(input) {
        if (input.classList.contains('is-unavailable')) return;

        const mainOption = this.form.querySelector(`variant-picker input[value="${CSS.escape(input.value)}"]`);
        if (mainOption) {
          mainOption.checked = true;
          mainOption.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (input.classList.contains('is-nonexistent')) return;

        this.form.dispatchEvent(new CustomEvent('sticky-cta-add'));
      }

      handleAvailabilityChange(event) {
        const { option, available, exists } = event.detail;
        const input = this.optionsPanel.querySelector(`input[value="${CSS.escape(option)}"]`);
        if (!input) return;

        input.classList.toggle('is-unavailable', !available);
        input.classList.toggle('is-nonexistent', !exists);
      }

      handleAdded(event) {
        const { variantId, featured_image, options_with_values } = event.detail || {};
        const image = this.summary.querySelector(TDStickyCTA.selectors.image);
        const priceEl = this.summary.querySelector(TDStickyCTA.selectors.price);
        const summaryOptions = this.summary.querySelector(TDStickyCTA.selectors.summaryOptions);

        if (featured_image && image) {
          const imageUrl = new URL(featured_image, window.location.origin);
          imageUrl.searchParams.set('width', '160');
          image.src = imageUrl.href;
        }

        // Reuse the variant picker's server-formatted prices so the summary matches the product money format setting.
        const formattedPrice = this.form.querySelector(TDStickyCTA.selectors.variantPicker)?.data?.formatted?.[variantId]?.price;
        if (formattedPrice && priceEl) {
          priceEl.textContent = formattedPrice;
          priceEl.dataset.variantId = variantId;
        }

        if (options_with_values && summaryOptions) {
          summaryOptions.replaceChildren(
            ...options_with_values.map((option) => {
              const span = document.createElement('span');
              span.textContent = `${option.name}: ${option.value}`;
              return span;
            })
          );
        }

        this.showPanel(this.summary);
        if (this.optionsPanel) {
          this.trigger.setAttribute('aria-expanded', 'false');
        }
        this.summary.querySelector(TDStickyCTA.selectors.close)?.focus();
      }

      showPanel(panel) {
        this.trigger.classList.add(TDStickyCTA.hiddenClass);
        this.optionsPanel?.classList.toggle(TDStickyCTA.hiddenClass, panel !== this.optionsPanel);
        this.summary.classList.toggle(TDStickyCTA.hiddenClass, panel !== this.summary);
      }

      reset() {
        this.trigger.classList.remove(TDStickyCTA.hiddenClass);
        this.optionsPanel?.classList.add(TDStickyCTA.hiddenClass);
        this.summary.classList.add(TDStickyCTA.hiddenClass);
        if (this.optionsPanel) {
          this.trigger.setAttribute('aria-expanded', 'false');
        }
      }
    }

    window.customElements.define('td-sticky-cta', TDStickyCTA);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-privacy-info-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('td-privacy-info-bar')) return;

  class TdPrivacyInfoBar extends HTMLElement {
    static get storageKey() {
      return 'td-privacy-dismissed';
    }

    static get customerPrivacyLoadTimeout() {
      return 2000;
    }

    static parseTargetList(str) {
      if (!str || typeof str !== 'string') return [];
      return str
        .split(',')
        .map((item) => item.trim().toUpperCase())
        .filter(Boolean);
    }

    static loadCustomerPrivacyApi() {
      const shopify = window.Shopify;
      if (!shopify) return Promise.resolve(null);

      if (shopify.customerPrivacy && typeof shopify.customerPrivacy.getRegion === 'function') {
        return Promise.resolve(shopify.customerPrivacy);
      }

      if (typeof shopify.loadFeatures !== 'function') return Promise.resolve(null);

      return new Promise((resolve) => {
        let settled = false;

        const finalize = (api) => {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeoutId);
          resolve(api || null);
        };

        const timeoutId = window.setTimeout(() => {
          finalize(shopify.customerPrivacy || null);
        }, TdPrivacyInfoBar.customerPrivacyLoadTimeout);

        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (error) {
            console.error('Failed to load Shopify Customer Privacy API:', error);
            finalize(null);
            return;
          }

          finalize(shopify.customerPrivacy || null);
        });
      });
    }

    static async checkGeoMatch(targetUsStates, targetCaProvinces) {
      const usStates = TdPrivacyInfoBar.parseTargetList(targetUsStates);
      const caProvinces = TdPrivacyInfoBar.parseTargetList(targetCaProvinces);

      if (usStates.length === 0 && caProvinces.length === 0) return false;

      const customerPrivacy = await TdPrivacyInfoBar.loadCustomerPrivacyApi();
      if (!customerPrivacy || typeof customerPrivacy.getRegion !== 'function') return false;

      try {
        const regionCode = String(customerPrivacy.getRegion() || '').trim().toUpperCase();
        if (regionCode.length < 4) return false;

        const country = regionCode.slice(0, 2);
        const region = regionCode.slice(2);

        if (country === 'US' && usStates.length > 0) {
          return usStates.includes(region);
        }

        if (country === 'CA' && caProvinces.length > 0) {
          return caProvinces.includes(region);
        }

        return false;
      } catch (error) {
        console.error('Privacy bar region check failed:', error);
        return false;
      }
    }

    static isDismissed(expiryDays) {
      try {
        const dismissedData = localStorage.getItem(TdPrivacyInfoBar.storageKey);
        if (!dismissedData) return false;

        const { expiry } = JSON.parse(dismissedData);
        if (Date.now() < expiry) {
          return true;
        }

        localStorage.removeItem(TdPrivacyInfoBar.storageKey);
        return false;
      } catch (error) {
        console.error('Error checking privacy dismissal:', error);
        return false;
      }
    }

    static setDismissed(expiryDays) {
      try {
        const expiry = Date.now() + expiryDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(TdPrivacyInfoBar.storageKey, JSON.stringify({ expiry }));
      } catch (error) {
        console.error('Error setting privacy dismissal:', error);
      }
    }

    connectedCallback() {
      this.expiryDays = parseInt(this.dataset.expiryDays, 10) || 30;
      this.acceptBtn = this.querySelector('[data-privacy-accept]');
      this.closeBtn = this.querySelector('[data-privacy-close]');

      this.init();
      this.setupEventListeners();
      this.setupDesignMode();
    }

    async init() {
      const shopify = window.Shopify || {};

      if (shopify.designMode) {
        this.show();
        return;
      }

      if (TdPrivacyInfoBar.isDismissed(this.expiryDays)) return;

      const matches = await TdPrivacyInfoBar.checkGeoMatch(
        this.dataset.targetUsStates || '',
        this.dataset.targetCaProvinces || ''
      );

      if (matches) this.show();
    }

    setupEventListeners() {
      if (this.acceptBtn) {
        this.acceptBtn.addEventListener('click', () => this.dismiss());
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.dismiss());
      }
    }

    setupDesignMode() {
      const shopify = window.Shopify || {};
      if (!shopify.designMode) return;

      document.addEventListener('shopify:section:select', (evt) => {
        if (evt.target === this.closest('.shopify-section')) {
          this.show();
        }
      });

      document.addEventListener('shopify:section:deselect', (evt) => {
        if (evt.target === this.closest('.shopify-section')) {
          this.hide();
        }
      });
    }

    show() {
      this.classList.remove('td-privacy-info-bar--hidden');
    }

    hide() {
      this.classList.add('td-privacy-info-bar--hidden');
    }

    dismiss() {
      const shopify = window.Shopify || {};
      if (!shopify.designMode) {
        TdPrivacyInfoBar.setDismissed(this.expiryDays);
      }
      this.hide();
    }
  }

  customElements.define('td-privacy-info-bar', TdPrivacyInfoBar);
})();

  } catch(e) { console.error(e); }
})();
})();
